import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LayoutModule } from 'app/shared/layout/layout.module';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'app/shared/shared.module';
import { ApiComponent } from './api.component';
import { apiRoutes } from './api.routes';
import { ApiKeyService } from './api-key.service';

@NgModule({
  imports: [LayoutModule, SharedModule, TranslateModule, RouterModule.forRoot(apiRoutes)],
  declarations: [ApiComponent],
  providers: [ApiKeyService]
})
export class ApiModule {}
